export const SET_VIEW_TYPE = 'SET_VIEW_TYPE';
export const SOCIAL_WALL_PAGINATION_LIMIT = 10;
